import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

import HomePage from './pages/HomePage';
import AboutBowtechPage from './pages/AboutBowtechPage';
import TreatmentPage from './pages/TreatmentPage';
import AboutJornPage from './pages/AboutJornPage';
import PricesPracticalPage from './pages/PricesPracticalPage';
import TestimonialsPage from './pages/TestimonialsPage';
import ContactPage from './pages/ContactPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="flex flex-col min-h-screen bg-[#fbfaf7] text-[#2b3648]">
      <ScrollToTop />
      <Navbar />

      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/projects" element={<AboutBowtechPage />} />
          <Route path="/behandlingen" element={<TreatmentPage />} />
          <Route path="/om-jorn" element={<AboutJornPage />} />
          <Route path="/about-us" element={<PricesPracticalPage />} />
          <Route path="/klienthistorier" element={<TestimonialsPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Legacy scrape URL redirects */}
          <Route path="/Hvad%20virker%20Bowtech%20p%C3%A5" element={<Navigate to="/projects" replace />} />
          <Route path="/Hvad-virker-Bowtech-paa" element={<Navigate to="/projects" replace />} />

          {/* Error pages */}
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      <Footer />
    </div>
  );
}
